const c1EarLeft = document.getElementById("c1-ear-left");
gsap.to(c1EarLeft, {
  rotate: 15,
  transformOrigin: "right",
  duration: 1,
  repeat: -1,
  yoyo: true,
});
const ear2 = document.getElementById("c1-ear-right");
gsap.to(ear2, {
  rotate: -15,
  transformOrigin: "left",
  duration: 1,
  repeat: -1,
  yoyo: true,
});

const su1 = document.getElementById("c1-su-left");
gsap.to(su1, {
  rotate: -5,
  transformOrigin: "right bottom",
  duration: 1,
  repeat: -1,
  yoyo: true,
});

const su2 = document.getElementById("c1-su-right");
gsap.to(su2, {
  rotate: 5,
  transformOrigin: "left bottom",
  duration: 1,
  repeat: -1,
  yoyo: true,
});

const leftArm = document.getElementById("c1-arm-left");
gsap.to(leftArm, {
  rotate: 10,
  transformOrigin: "right bottom",
  duration: 1,
  repeat: -1,
  yoyo: true,
});

const rightArm = document.getElementById("c1-arm-right");
gsap.to(rightArm, {
  rotate: -10,
  transformOrigin: "left bottom",
  duration: 1,
  repeat: -1,
  yoyo: true,
});

const mainBody = document.getElementById("main-body");
gsap.to(mainBody, {
  y: -5,
  duration: 1,
  repeat: -1,
  yoyo: true,
});

const leftEar = document.getElementById("c1-pipe-left");
gsap.to(leftEar, {
  rotate: -5,
  transformOrigin: "right top",
  duration: 1,
  repeat: -1,
  yoyo: true,
});
const c1PipeRight = document.getElementById("c1-pipe-right");
gsap.to(c1PipeRight, {
  rotate: 5,
  transformOrigin: "top",
  duration: 1,
  repeat: -1,
  yoyo: true,
});

//character 2
const light = document.getElementById("light");
gsap.to(light, {
  rotate: -5,
  transformOrigin: "top",
  duration: 1.5,
  repeat: -1,
  yoyo: true,
});

const c2Su1 = document.getElementById("c2-su-2");
gsap.to(c2Su1, {
  rotate: -5,
  transformOrigin: "right bottom",
  duration: 1.5,
  repeat: -1,
  yoyo: true,
});

const c2Su2 = document.getElementById("c2-su-1");
gsap.to(c2Su2, {
  rotate: 5,
  transformOrigin: "left bottom",
  duration: 1.5,
  repeat: -1,
  yoyo: true,
});

const c2EarLeft = document.getElementById("c2-ear-left");
gsap.to(c2EarLeft, {
  rotate: -15,
  transformOrigin: "right bottom",
  duration: 1.5,
  repeat: -1,
  yoyo: true,
  delay: 0.75,
});
const c2EarRight = document.getElementById("c2-ear-right");
gsap.to(c2EarRight, {
  rotate: 15,
  transformOrigin: "left bottom",
  duration: 1.5,
  repeat: -1,
  yoyo: true,
  delay: 0.75,
});

const c2GlassLeft = document.getElementById("c2-glass-left");
gsap.to(c2GlassLeft, {
  rotate: -5,
  transformOrigin: "right bottom",
  duration: 1.5,
  repeat: -1,
  yoyo: true,
});

const c2GlassRight = document.getElementById("c2-glass-right");
gsap.to(c2GlassRight, {
  rotate: 5,
  transformOrigin: "bottom",
  duration: 1.5,
  repeat: -1,
  yoyo: true,
});

const c2ArmRight = document.getElementById("c2-arm-right");
gsap.to(c2ArmRight, {
  rotate: -10,
  transformOrigin: "left",
  duration: 1.5,
  repeat: -1,
  yoyo: true,
});

const c2ArmLeft = document.getElementById("c2-arm-left");
gsap.to(c2ArmLeft, {
  rotate: -10,
  transformOrigin: "top",
  duration: 1.5,
  repeat: -1,
  yoyo: true,
});
const c2ArmLeft2 = document.getElementById("c2-arm-left2");
gsap.to(c2ArmLeft2, {
  rotate: -5,
  transformOrigin: "left",
  x: 10,
  duration: 1.5,
  repeat: -1,
  yoyo: true,
});
const c2PipeLeft = document.getElementById("c2-pipe-left");
gsap.to(c2PipeLeft, {
  rotate: -5,
  transformOrigin: "top",
  duration: 1.5,
  repeat: -1,
  yoyo: true,
});
const c2PipeRight = document.getElementById("c2-pipe-right");
gsap.to(c2PipeRight, {
  rotate: 5,
  transformOrigin: "top",
  duration: 1.5,
  repeat: -1,
  yoyo: true,
});

//character 3
const c3LegLeft = document.getElementById("c3-leg-left");
gsap.to(c3LegLeft, {
  rotate: -8,
  transformOrigin: "bottom",
  duration: 1,
  repeat: -1,
  yoyo: true,
  y: 3,
});
const c3LegLeft2 = document.getElementById("c3-leg-left2");
gsap.to(c3LegLeft2, {
  rotate: 10,
  transformOrigin: "top",
  duration: 1,
  repeat: -1,
  yoyo: true,
  y: -2,
});

const c3LegRight2 = document.getElementById("c3-leg-right2");
gsap.to(c3LegRight2, {
  rotate: -10,
  transformOrigin: "top",
  duration: 1,
  repeat: -1,
  yoyo: true,
  y: -2,
});
const c3LegRight = document.getElementById("c3-leg-right");
gsap.to(c3LegRight, {
  rotate: 9,
  transformOrigin: "bottom",
  duration: 1,
  repeat: -1,
  yoyo: true,
  y: 5,
});
const c3Body = document.getElementById("c3-body");
gsap.to(c3Body, {
  y: 10,
  duration: 1,
  repeat: -1,
  yoyo: true,
});

const c2SuLeft = document.getElementById("c3-su-left");
gsap.to(c2SuLeft, {
  rotate: -5,
  transformOrigin: "right bottom",
  duration: 1,
  repeat: -1,
  yoyo: true,
});

const c3SuRight = document.getElementById("c3-su-right");
gsap.to(c3SuRight, {
  rotate: 5,
  transformOrigin: "left bottom",
  duration: 1,
  repeat: -1,
  yoyo: true,
});

const c3EarLeft = document.getElementById("c3-ear-left");
gsap.to(c3EarLeft, {
  rotate: -15,
  transformOrigin: "right bottom",
  duration: 1,
  repeat: -1,
  yoyo: true,
});
const c3EarRight = document.getElementById("c3-ear-right");
gsap.to(c3EarRight, {
  rotate: 15,
  transformOrigin: "left bottom",
  duration: 1,
  repeat: -1,
  yoyo: true,
});
const c3Coat = document.getElementById("c3-coat");
gsap.to(c3Coat, {
  rotate: 10,
  x: -10,
  transformOrigin: "left",
  duration: 1,
  repeat: -1,
  yoyo: true,
});

const c3PipeLeft = document.getElementById("c3-pipe-left");
gsap.to(c3PipeLeft, {
  rotate: -5,
  transformOrigin: "top",
  duration: 1,
  repeat: -1,
  yoyo: true,
});
const c3PipeRight = document.getElementById("c3-pipe-right");
gsap.to(c3PipeRight, {
  rotate: 5,
  transformOrigin: "top",
  duration: 1,
  repeat: -1,
  yoyo: true,
});

const c4ArmRight = document.getElementById("c4-arm-right");
gsap.to(c4ArmRight, {
  x: -10,
  y: 3.5,
  rotate: 35,
  transformOrigin: "bottom right",
  duration: 1.5,
  repeat: -1,
  yoyo: true,
});

const c5EarLeft = document.getElementById("c5-ear-left");
gsap.to(c5EarLeft, {
  rotate: 15,
  transformOrigin: "right",
  duration: 1,
  repeat: -1,
  yoyo: true,
});

const c5EarRight = document.getElementById("c5-ear-right");
gsap.to(c5EarRight, {
  rotate: -15,
  transformOrigin: "left",
  duration: 1,
  repeat: -1,
  yoyo: true,
});

const c5SuLeft = document.getElementById("c5-su-left");
gsap.to(c5SuLeft, {
  rotate: -5,
  transformOrigin: "right bottom",
  duration: 1,
  repeat: -1,
  yoyo: true,
});

const c5SuRight = document.getElementById("c5-su-right");
gsap.to(c5SuRight, {
  rotate: 5,
  transformOrigin: "left bottom",
  duration: 1,
  repeat: -1,
  yoyo: true,
});

const c5PipeRight = document.getElementById("c5-pipe-right");
gsap.to(c5PipeRight, {
  rotate: 5,
  transformOrigin: "top",
  duration: 1,
  repeat: -1,
  yoyo: true,
});

const c5ArmRight = document.getElementById("c5-arm-right");
gsap.to(c5ArmRight, {
  rotate: -10,
  transformOrigin: "left bottom",
  duration: 1,
  repeat: -1,
  yoyo: true,
});

